







import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { extend, localize } from "vee-validate";

import * as rules from "vee-validate/dist/rules";
// @ts-ignore
import en from "@/localization/en/validation";
// @ts-ignore
import jp from "@/localization/jp/validation";
// @ts-ignore
import cn from "@/localization/cn/validation";

const lang = localStorage.getItem(`${process.env.VUE_APP_NAME}_LANG`);
switch (lang) {
  case "jp":
    localize("jp", jp);
    break;
  case "cn":
    localize("cn", cn);
    break;
  default:
    localize("en", en);
    break;
}

interface Rules {
  [key: string]: any;
}
const customRules: Rules = rules;
Object.keys(customRules).forEach((rule: string) => {
  extend(rule, customRules[rule]);
});

for (const [rule, validation] of Object.entries(rules)) {
  //@ts-ignore
  extend(rule, { ...validation });
}

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    FormButton: () => import("./submit.vue"),
  },
})
export default class FormBase extends Vue {
  @Ref() readonly observer!: InstanceType<typeof ValidationObserver>;

  @Prop() beforeLoad?: () => Promise<void>;

  loading = false;

  success = false;

  reset(): void {
    this.loading = false;
    this.success = false;

    this.$emit("reset");
  }

  async submit(): Promise<boolean> {
    this.loading = true;
    this.success = false;
    const isValid: boolean = await this.observer.validate();

    if (!isValid) {
      return (this.loading = false);
    }

    this.$emit("submit", this);

    return isValid;
  }

  get isValid() {
    return this.observer.flags.valid;
  }
}
